var map = {
	"./output-1.png": "8d6b",
	"./output-2.png": "2533",
	"./output-3.png": "c932",
	"./output_main.png": "f643",
	"./output_more.png": "6bcb",
	"./output_suggestion.png": "b68e",
	"./persona_01.jpg": "957b",
	"./persona_01.png": "e2d9",
	"./persona_02.jpg": "561b",
	"./persona_02.png": "8db7",
	"./pic-grid.png": "3ad4",
	"./shapes.svg": "4c42",
	"./target-1.jpg": "259d",
	"./target-2.jpg": "1019",
	"./target-3.jpg": "827c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6a9c";